/**
 * Hash string, used in password's hash value generation
 * */
export const HASH_STRING = 'oZ7QE6LcLJp6fiWzdqZc';
